import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar } from 'redux/navigation'
import { Menu } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      hideSidebar,
    },
    dispatch
  )
}

class NavigationLink extends React.Component {
  render() {
    const { children, item, push, hideSidebar } = this.props

    return (
      <Menu.Item
        {...{
          className: 'header ellipsis',
          as: 'a',
          children: children ? children : item.content,
          active: item.active,
          href: item.path,
          key: item.key,
          onClick: (event) => {
            event.preventDefault()
            push(item.path)
            hideSidebar()
          },
        }}
      />
    )
  }
}

NavigationLink = connect(mapStateToProps, mapDispatchToProps)(NavigationLink)
export default NavigationLink



// WEBPACK FOOTER //
// ./src/components/shared/Navigation/renditions/NavigationLink.jsx